// Option lists for AddListing form dropdowns.
// These mirror filterOptions.js but include all admin-writable values.
// import speakers from "../assets/Images/speakers.jpg";
// import projectors from "../assets/Images/headlights.jpg";
// import infotainment from "../assets/Images/infotainment-system.jpg";
// import gps_trackers from "../assets/Images/gps-trackers.jpg";
// import cameras from "../assets/Images/dash-cam.jpg";

export const MAKES = [
  "Toyota",
  "Mazda",
  "Subaru",
  "Mercedes-Benz",
  "Honda",
  "Nissan",
  "Volkswagen",
  "Mitsubishi",
  "BMW",
  "Audi",
  "Ford",
  "Isuzu",
  "Hyundai",
  "Kia",
  "Peugeot",
  "Renault",
];

export const BODY_TYPES = [
  "Sedan",
  "SUV",
  "Pickup",
  "Crossover",
  "Hatchback",
  "Van",
  "Minivan",
  "Coupe",
  "Wagon",
];

export const FUEL_TYPES = ["Petrol", "Diesel", "Hybrid", "Electric", "LPG"];

export const TRANSMISSIONS = ["Automatic", "Manual", "CVT", "Semi-automatic"];

export const CONDITIONS = ["New", "Nearly new", "Foreign used", "Locally used"];

export const DRIVE_TRAINS = ["FWD", "RWD", "AWD", "4WD"];

export const LOCATIONS = [
  "Nairobi",
  "Mombasa",
  "Nakuru",
  "Kisumu",
  "Eldoret",
  "Thika",
  "Machakos",
  "Nyeri",
  "Meru",
];

export const CURRENCIES = ["KES", "USD"];

export const ACCESSORY_CATEGORIES = [
  {
    value: "projectors",
    label: "Projectors & Lighting",
    description:
      "We provide you with the best projectors in the market to help you elevate your lighting and make sure you can see well at night and at long ranges further than what most basic default lighting options offer",
    //image: projectors,
  },
  {
    value: "speakers",
    label: "Speakers",
    description:
      "We provide you with the best projectors in the market to help you elevate your lighting and make sure you can see well at night and at long ranges further than what most basic default lighting options offer",
    //image: speakers,
  },
  {
    value: "infotainment",
    label: "Infotainment Systems",
    description:
      "We provide you with the best projectors in the market to help you elevate your lighting and make sure you can see well at night and at long ranges further than what most basic default lighting options offer",
    //image: infotainment,
  },
  {
    value: "gps_trackers",
    label: "GPS Trackers",
    description:
      "We provide you with the best projectors in the market to help you elevate your lighting and make sure you can see well at night and at long ranges further than what most basic default lighting options offer",
    //image: gps_trackers,
  },

  {
    value: "cameras",
    label: "Cameras & Dash Cams",
    description:
      "We provide you with the best projectors in the market to help you elevate your lighting and make sure you can see well at night and at long ranges further than what most basic default lighting options offer",
    //image: cameras,
  },
];

export const SPARE_CATEGORIES = [
  { value: "engine", label: "Engine Parts" },
  { value: "transmission", label: "Transmission & Drivetrain" },
  { value: "suspension", label: "Suspension & Steering" },
  { value: "brakes", label: "Brakes & Wheels" },
  { value: "electrical", label: "Electrical & Lighting" },
  { value: "exhaust", label: "Exhaust System" },
  { value: "cooling", label: "Cooling System" },
  { value: "fuel", label: "Fuel System" },
  { value: "interior", label: "Interior Parts" },
  { value: "body", label: "Body & Trim" },
  { value: "filters", label: "Filters" },
  { value: "belts", label: "Belts & Hoses" },
  { value: "fluids", label: "Fluids & Lubricants" },
  { value: "other", label: "Other Parts" },
];

export const BADGES = {
  vehicle: ["Featured", "Hot Deal", "Nearly New", "Eco Choice", ""],
  accessory: [
    "Best Seller",
    "Top Rated",
    "New Arrival",
    "Premium",
    "Best Value",
    "",
  ],
  spare: [
    "Best Seller",
    "OEM",
    "Aftermarket",
    "Bulk Discount",
    "Limited Stock",
    "",
  ],
};
